/**
 * Page Background Manager
 * Adds decorative background images to story and collection pages
 */

class PageBackgroundManager {
  constructor() {
    this.storyBgUrl = 'https://cdn.shopify.com/s/files/1/0776/0573/2572/files/story_footer-bg.png?v=1766050562';
    this.collectionBgUrl = 'https://cdn.shopify.com/s/files/1/0776/0573/2572/files/ea_bg-optimized.jpg?v=1766158286';
    this.storyPath = '/pages/story';
    this.footerSectionId = '#shopify-section-sections--21092708319452__footer_m9NzUG';
    this.footerUtilityId = '#shopify-section-sections--21092708319452__footer_utilities_jLGE8U';
    this.styleElement = null;
    this.init();
  }

  init() {
    const currentPath = window.location.pathname;
    
    // Handle story page with ::before pseudo-element
    if (this.isStoryPage()) {
      this.addStoryBackgroundStyles();
      this.setupBodyPosition();
    }
    // Handle collection pages with direct body background
    else if (this.isCollectionPage()) {
      this.addCollectionBackground();
      this.addCollectionStyles();
    }
  }

  isStoryPage() {
    return window.location.pathname === this.storyPath;
  }

  isCollectionPage() {
    const currentPath = window.location.pathname;
    return currentPath.startsWith('/collections/');
  }

  addStoryBackgroundStyles() {
    // Prevent duplicate styles
    if (document.getElementById('story-footer-bg-styles')) {
      return;
    }

    // Create style element
    this.styleElement = document.createElement('style');
    this.styleElement.id = 'story-footer-bg-styles';
    
    // Add CSS for body::before and footer sections
    this.styleElement.textContent = `
      body::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('${this.storyBgUrl}');
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: contain;
        pointer-events: none;
        z-index: 2;
      }

      ${this.footerSectionId} {
        position: relative;
        z-index: 3;
        background-color: #0000004d;
      }

      ${this.footerUtilityId} {
        position: relative;
        z-index: 3;
      }
    `;

    // Append to head
    document.head.appendChild(this.styleElement);
  }

  addCollectionBackground() {
    // Apply background styles directly to body
    document.body.style.backgroundImage = `url('${this.collectionBgUrl}')`;
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundPosition = 'bottom center';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundAttachment = 'fixed';
  }

  addCollectionStyles() {
    // Prevent duplicate styles
    if (document.getElementById('collection-overlay-styles')) {
      return;
    }

    // Create style element for collection page overlay
    const collectionStyleElement = document.createElement('style');
    collectionStyleElement.id = 'collection-overlay-styles';
    
    // Add CSS for body overlay and footer background
    collectionStyleElement.textContent = `
      body::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        pointer-events: none;
        z-index: 0;
      }

      body > * {
        position: relative;
        z-index: 1;
      }

      ${this.footerSectionId} {
        background-color: #0000004d !important;
      }
    `;

    // Append to head
    document.head.appendChild(collectionStyleElement);
  }

  setupBodyPosition() {
    const bodyPosition = window.getComputedStyle(document.body).position;
    
    // Ensure body has position relative for absolute pseudo-element positioning
    if (bodyPosition === 'static') {
      document.body.style.position = 'relative';
    }

    // Ensure body has minimum height
    if (!document.body.style.minHeight) {
      document.body.style.minHeight = '100vh';
    }
  }

  /**
   * Remove background styles (useful for cleanup or SPA navigation)
   */
  remove() {
    // Remove story page styles
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
      this.styleElement = null;
    }
    
    // Remove collection overlay styles
    const collectionStyles = document.getElementById('collection-overlay-styles');
    if (collectionStyles && collectionStyles.parentNode) {
      collectionStyles.parentNode.removeChild(collectionStyles);
    }
    
    // Remove collection page styles
    document.body.style.backgroundImage = '';
    document.body.style.backgroundRepeat = '';
    document.body.style.backgroundPosition = '';
    document.body.style.backgroundSize = '';
    document.body.style.backgroundAttachment = '';
    
    // Optionally reset body styles
    // document.body.style.position = '';
    // document.body.style.minHeight = '';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    new PageBackgroundManager();
  });
} else {
  new PageBackgroundManager();
}

// Export for module usage (if using modules)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = PageBackgroundManager;
}